import { gql, useQuery } from '@sortlist-frontend/data-fetching/public';

export const AGENCY_SEO_QUERY = gql(`
  query Agency($slug: String!) {
    agency(slug: $slug) {
      ...AgencyFragment
      id
      name
      description
      coverPictureUrl
      logoUrl
      tagline
      description
      updatedAt
      foundedAt
      languages
      teamSize
      # Note: the offices query causes a 500 for some agencies
      offices {
        totalCount
        nodes {
          id
          address
          locality {
          id
          name
          slug
          country {
            id
            name
            iso31661
          }
        }
        }
      }
      awards{
        nodes {
          id
          name
        }
      }
      works {
        nodes {
          id
          name
          slug
          description
          # illustrationUrls
          solutions
          aspects {
            nodes {
              id
              expertise {
                id
                name
              }
            }
          }
          company {
            id
            name
          }
        }
      }
      reviews(first: 50) {
        nodes {
          id
          rating
          userFullName
          descriptionSummary
          service {
            id
            expertise {
              id
              name
            }
          }
        }
      }
      mainOffice {
        id
        locality {
          id
          name
          slug
          country {
            id
            name
          }
        }
      }
    }
  }
`);

export const useGetAgency = (slug: string) => {
  return useQuery(AGENCY_SEO_QUERY, {
    variables: {
      slug,
    },
  });
};
